import { getWorkflowStageKey } from "./getWorkflowStageKey";

export const orderWorkflowStageKeys = (stageKeys: string[], orderedPhaseNames: string[] = []): string[] => {
  if (!orderedPhaseNames.length) {
    return stageKeys;
  }

  const phaseOrderByStageKey = new Map(
    orderedPhaseNames.map((phaseName, index) => [getWorkflowStageKey(phaseName), index])
  );

  return [...stageKeys].sort((leftKey, rightKey) => {
    const leftIndex = phaseOrderByStageKey.get(leftKey);
    const rightIndex = phaseOrderByStageKey.get(rightKey);

    if (leftIndex === undefined && rightIndex === undefined) {
      return stageKeys.indexOf(leftKey) - stageKeys.indexOf(rightKey);
    }

    if (leftIndex === undefined) {
      return 1;
    }

    if (rightIndex === undefined) {
      return -1;
    }

    return leftIndex - rightIndex;
  });
};
